import $ from 'jquery';
import './console';
import './animations';
import './booking-form';
import Header from './header';
import './overview';
import './slider';

$(function () {
	var header = new Header('[data-header]');
});
